import React from 'react';
import ContentLayout from '../../../components/ContentLayout';
import props from '../../../lib/contentLayoutProps/admissions/layoutProps';

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="zh" pageKey="school-tour">
    <h1>校園導賞團</h1>
    <p>我們定期(每個月第一個星期三)舉辦校園導賞團，由學校領導層帶領各位參觀各校舍。</p>
    <p>有興趣的家庭歡迎致電 2337 9031或電郵至 enquiry@kingston.edu.hk登記。</p>
  </ContentLayout>
);
